import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import lodash from 'lodash';
import Select from 'react-select';

import Field from '../../util/field/Field';
import ErrorMessages from '../../../util/validation-error-messages';
//Services
import ComboDatosAPI from '../../../services/ComboDatos';
import Loading from '../../util/loading/Loading';


const SCHEMA = Yup.object({
    estadoId: Yup.object().required("El campo 'Estado' es requerido.").nullable(),
    municipioId: Yup.object().required("El campo 'Ciudad' es requerido.").nullable(),
    coloniaId: Yup.object().required("El campo 'Colonia' es requerido.").nullable(),
    CP: Yup.string().max(5, 'Ha excedido el límite de 5 caracteres.').required("El campo 'Código postal' es requerido."),
    calle: Yup.string().trim().max(50, 'Ha excedido el límite de 50 caracteres.').required("El campo 'Calle principal' es requerido."),
    numero: Yup.string().trim().max(8, "Ha excedido el límite de 8 caracteres.")
        .matches(/^[a-zA-Z0-9 \-_]*$/, { message: "Formato incorrecto, se permiten solo - _ y números." })
        .required("El campo 'Número exterior' es requerido."),
    entreCalles: Yup.string().trim().max(80, 'Ha excedido el límite de 80 caracteres.').required("El campo 'Entre calles' es requerido."),    
});

const hrWithLegend = (text, bold, textAlign) => {
    return (
        <div style={{
            "marginTop": 20,
            "marginBottom": 20,
            "marginLeft": textAlign && textAlign !== 'center' ? 20 : 0,
            "border": 0,
            "borderTop": '1px solid #eee',
            "textAlign": textAlign || 'center',
            "height": 0,
            "lineHeight": 0
        }} className="hr">
            {
                text &&
                <span className="category" style={{
                    "backgroundColor": '#fff',
                    "paddingLeft": 20,
                    "paddingRight": 20,
                    "fontSize": 16,
                    "fontWeight": bold ? "bold" : "normal"
                }}>
                    {
                        text
                    }</span>
            }

        </div>
    )
}

/**
 * Formulario con la información general del folio
 */
export const StepLocationDrive = ({ ...props }) => {
    const [state, setState] = useState({
        isLoading: false,
        arrStates: [],
        arrCities: [],
        arrSuburbios: [],
        arrZipCodes: []
    })
    const [newColonia , setNewColonia] = useState("");
    const [puntoVenta, setPuntoVenta]  = useState({
        estadoId: null,
        municipioId:null,
        coloniaId: null,
        CP:null,
        calle:null,
        numero:null,
        entreCalles: null
    });

    /**Carga información del form */
    useEffect(() => {
        setState({
            ...state,
            isLoading: true
        });
        let arrStates = []; 
        let arrCities = [];
        let arrSuburbios =  [];

        let pdv = {...props.caffenio}        
        ComboDatosAPI.getAllDirState()
            .then(response => {
                arrStates = lodash.sortBy(response.data.map(x=> {x.label = x.Name ; x.value = x.StateId; return x;}), [ts => ts.Name.toLowerCase()], ['asc'])
                if (pdv.estadoId && arrStates && arrStates.length > 0){
                    pdv.estadoId = arrStates.find(val => val.StateId == pdv.estadoId);
                    return ComboDatosAPI.getCityWithStateRef(pdv.estadoId.label)
                }
            }).then(response => { 
                arrCities = response && response.data ? lodash.sortBy(response.data.map(x=> {x.label = x.Name ; x.value = x.Name; return x;}), [ts => ts.Name.toLowerCase()], ['asc']) : []
                if (pdv.municipioId && arrCities && arrCities.length > 0){
                    pdv.municipioId = arrCities.find(val => val.Name == pdv.municipio);
                    return ComboDatosAPI.getDirSuburb(pdv.municipioId.label)
                }
                
            }).then(response => {  
                
                arrSuburbios = response && response.data ? lodash.sortBy(response.data.map(x=> {x.label = x.Name ; x.value = x.Name; return x;}), [ts => ts.Name.toLowerCase()], ['asc']) : []
                if (pdv.coloniaId && arrSuburbios){
                    if(arrSuburbios.length == 0){
                        const newOption = {label: pdv.colonia, value: pdv.coloniaId}
                        arrSuburbios =  [...state.arrSuburbios, newOption]
                    }
                    pdv.coloniaId = arrSuburbios.find(val => val.label == pdv.colonia);
                }

                setState({
                    ...state,
                    isLoading: false,
                    arrStates,
                    arrCities,
                    arrSuburbios                    
                });
                setPuntoVenta(pdv);                          
            })
            .catch(err => {
                setState({
                    ...state,
                    isLoading: false
                })
                if (err.response)
                    toast.error(err.response.data.Message)
                else
                    toast.error(ErrorMessages.SinConexion)
            })
    }, []);
    
    const handleInputChange = (input) => {
        setNewColonia(input);
    };


    const handleFilterChange = (filtername, value) => { 
        switch(filtername){
            case "estadoId":
                if(value)
                    getCities(value.Name);
                else{
                    setState({...state, arrCities: []});
                }
                break;
            case "municipioId":
                if(value)
                    getSuburbios(value.Name);
                else{
                    setState({...state, arrSuburbios: []});
                }
                break;
            default:                break;
                
        }

    }

    /**Obtiene ciudades a partir de estado */
    const getCities = (stateName) => {
        setState({
            ...state,
            isLoading: true
        });
        let arrCities = [];        
        ComboDatosAPI.getDirCity(stateName).then(response => {
            arrCities =  lodash.sortBy(response.data.map(x=> {x.label = x.Name ; x.value = x.Name; return x;}), [ts => ts.Name.toLowerCase()], ['asc'])            
        })
        .catch(err => {            
            if (err.response)
                toast.error(err.response.data.Message)
            else
                toast.error(ErrorMessages.SinConexion)
        }).finally(() => {
            setState({
                ...state,
                arrCities,
                arrSuburbios: [],
                isLoading: false,
            });
        });
    }

    /**Obtiene colonias a partir de ciudad */
    const getSuburbios = (cityName) => {
        setState({
            ...state,
            isLoading: true
        });
        let arrSuburbios = [];
        
        ComboDatosAPI.getDirSuburb(cityName).then(response => {
            arrSuburbios = response.data.map(d => { return { label: d.Name, value: d.Name } });            
        }).catch(err => {           
            if (err.response)
                toast.error(err.response.data.Message)
            else
                toast.error(ErrorMessages.SinConexion)
        }).finally(() => {
            setState({
                ...state,
                arrSuburbios,
                isLoading: false,
            });
        });
    }
    
    const handleKeyDown = (event, callback) => {
        if (!newColonia) return;

        // Enter crea el valor
        if (event.key === "Enter") {
            const exists = state.arrSuburbios.some(
                (o) => o.label.toLowerCase() === newColonia.toLowerCase()
            );
            if (exists) return;

            const newOption = {
                label: newColonia,
                value: newColonia.toLowerCase().replace(/\s+/g, "-"),
            };

            let arrSuburbios =  [...state.arrSuburbios, newOption]
            setState({
                ...state,
                arrSuburbios,
            })
            callback("coloniaId",newOption);
        }
    };
    
    const mapValues= (values) => {
        let caffenioUpdated = {...values};
        
        caffenioUpdated.estado = values.estadoId ? values.estadoId.label : null; 
        caffenioUpdated.municipio = values.municipioId ? values.municipioId.label : null; 
        caffenioUpdated.colonia = values.coloniaId ? values.coloniaId.label : null;  
        
        return caffenioUpdated;

    }
    return (
        <Formik
            enableReinitialize={true}
            initialValues={puntoVenta}
            validationSchema={SCHEMA}
            onSubmit={(values) => {   
                let caffenioUpdated = mapValues(values);
                props.save(caffenioUpdated)
            }}>
            {({ values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched }) => (
                <form onSubmit={handleSubmit} id="frmLocationDriveStep">
                    {hrWithLegend('Ubicación', false, 'left')}
                    <div className="columns is-multiline">                         
                        <div className="column is-4">
                            <Field label="Estado"
                                hasError={errors.estadoId }
                                msgError={errors.estadoId && touched.estadoId ? errors.estadoId : ""}>
                                    <div className="column is-12">
                                    <Select
                                        placeholder={"Seleccionar..."}
                                        name={"estadoId"}
                                        value={values.estadoId}
                                        onChange={(val) => { 
                                            //Carga ciudades
                                            handleFilterChange("estadoId", val);                                            
                                            setFieldValue('estadoId', val);
                                            setFieldValue('municipioId', null);
                                            setFieldValue('coloniaId', null);
                                        }}
                                        noOptionsMessage={() => "No hay opciones"}
                                        options={state.arrStates}
                                        isClearable 
                                        />

                                    </div>
                                
                            </Field>
                        </div>
                        <div className="column is-4">
                            <Field label="Ciudad"
                                hasError={errors.municipioId }
                                msgError={errors.municipioId && touched.municipioId ? errors.municipioId : ""}>
                                    <div className="column is-12">
                                    <Select
                                        placeholder={"Seleccionar..."}
                                        name={"municipioId"}
                                        value={values.municipioId}
                                        onChange={(val) => { 
                                            handleFilterChange("municipioId", val)
                                            setFieldValue('municipioId', val) 
                                            setFieldValue('coloniaId', null);
                                        }}
                                        noOptionsMessage={() => "No hay opciones"}
                                        options={state.arrCities}
                                        isClearable 
                                        isDisabled={!values.estadoId}/>
                                    </div>
                            </Field>
                        </div>
                        <div className="column is-4">
                            <Field label="Colonia"
                                hasError={errors.coloniaId }
                                msgError={errors.coloniaId && touched.coloniaId ? errors.coloniaId : ""}>
                                    <div className="column is-12">
                                    <Select
                                        placeholder={"Seleccionar..."}
                                        name={"coloniaId"}
                                        value={values.coloniaId}
                                        onChange={(val) => { setFieldValue('coloniaId', val) }}                                        
                                        noOptionsMessage={() => "No hay opciones"}
                                        options={state.arrSuburbios}
                                        isClearable 
                                        isDisabled={!values.municipioId}
                                        onInputChange={handleInputChange}
                                        onKeyDown={(e)=>handleKeyDown(e, setFieldValue)}/>
                                    </div>
                            </Field>
                        </div>
                    </div>
                    {hrWithLegend('Dirección', false, 'left')}
                    <div className="columns is-multiline">
                        <div className="column is-4">
                            <Field label="CP"
                                hasError={errors.CP}
                                msgError={errors.CP && touched.CP ? errors.CP : ""}>
                                <input
                                    className="input some-top"
                                    type="number"
                                    min="0"
                                    max="99999"
                                    label="Código Postal"
                                    name="CP"
                                    value={values.CP || ""}
                                    onChange={(e) => handleChange(e)} />
                            </Field>
                        </div>
                        <div className="column is-8">
                            <Field label="Calle Principal"
                                hasError={errors.calle}
                                msgError={errors.calle && touched.calle ? errors.calle : ""}>
                                <input
                                    className="input some-top"
                                    maxLength="100"
                                    label="calle"
                                    name="calle"
                                    value={values.calle || ""}
                                    onChange={(e) => handleChange(e)} />
                            </Field>
                        </div>
                        <div className="column is-4">
                            <Field label="Número exterior"
                                hasError={errors.numero}
                                msgError={errors.numero && touched.numero ? errors.numero : ""}>
                                <input
                                    className="input"
                                    label="numero"
                                    name="numero"
                                    value={values.numero || ""}
                                    onChange={(e) => handleChange(e)} />
                            </Field>
                        </div>
                        <div className="column is-8">
                            <Field label="Entre Calles"
                                hasError={errors.entreCalles }
                                msgError={errors.entreCalles && touched.entreCalles ? errors.entreCalles : ""}>
                                <input className="input" maxLength="80" label="entreCalles"
                                    name="entreCalles"
                                    value={values.entreCalles || ""}
                                    onChange={(e) => handleChange(e)} />
                            </Field>
                        </div>
                    </div>

                    <br />

                    <div className="has-text-left buttons-modal" id="stepActions">
                        <div className="pull-left">
                            <button id="btnBackStepLocationDrive" type="button" className="button is-light" onClick={() => {
                                props.back({...props.caffenio})}} >Anterior</button>

                        </div>
                    </div>
                    <div className="has-text-right buttons-modal" id="stepActions">
                        <div className="pull-right">
                            <button id="btnSaveStepLocationDrive" type="submit" className="button is-success"  style={{marginRight:"5px"}} >Guardar dirección</button>
                            <button id="btnSaveAllStepLocationDrive" type="button" className="button is-warning" onClick={() =>props.saveAll(mapValues(values))} >Guardar Todo</button>
                        </div>
                    </div>
                    {
                        state.isLoading &&
                        <Loading
                            isFullscreen={true}
                            isLoading={state.isLoading}
                            width='100px'
                            height='100px'
                        />
                    }
                </form>
            )}

        </Formik>
    );

}

export default StepLocationDrive;